import { DatePicker, DatePickerProps } from "antd";
import React from "react";
export const UI_ITODatePicker = (props: DatePickerProps) => {
  return (
    <DatePicker {...props} format={{ format: "DD.MM.YYYY", type: "mask" }} />
  );
};
